module.exports = __webpack_public_path__ + "img/3.b24f1d4f.png";